//third-party
import { useState, useContext } from "react";
import { createPortal } from "react-dom";
//custom modules
import { uploadFile } from "../CommonFunc";
//styles
import "./FileLoad.scss";
import { AppContext } from "../../Context/AppContext";

const uploadStates = {
	idle: "idle",
	inprogress: "inprogress",
	success: "success",
	error: "error",
};

export default function FileLoad({ setLoad }) {
	//contexts
	const { theme } = useContext(AppContext);

	//states
	const [state, setState] = useState({
		selectedFile: null,
		fileName: "",
		fileDate: new Date().toISOString().split("T")[0],
	});
	const [uploadState, setUploadState] = useState(uploadStates.idle);

	//variables
	const selectedFileName = (rawName) => {
		let name = "";
		if (rawName) {
			let arrayName = rawName.split(".");
			arrayName.pop();
			name = arrayName.join(".");
			return name;
		} else {
			return name;
		}
	};

	//#region functions
	const handleChange = (event) => {
		if (
			event.target?.files?.[0]?.size &&
			event.target?.files?.[0]?.size > 20971520
		) {
			event.target.value = null;
			console.log("File is too big");
			return;
		}
		switch (event.target.name) {
			case "file-name":
				setState((prev) => ({ ...prev, fileName: event.target.value }));
				break;
			case "file-date":
				setState((prev) => ({ ...prev, fileDate: event.target.value }));
				break;
			case "file":
				setState((prev) => ({
					selectedFile: event.target.files,
					fileDate: new Date().toISOString().split("T")[0],
					fileName: selectedFileName(event.target.files[0]?.name),
				}));
				break;
			default:
				break;
		}
	};

	// On file upload (click the upload button)
	const onFileUpload = async () => {
		const formData = new FormData();
		formData.append("fileName", state.fileName || "_");
		formData.append("fileDate", state.fileDate);
		//formData.append("file", state.selectedFile, state.selectedFile.name);
		for (const file of state.selectedFile) {
			formData.append("file", file, file.name);
		}
		setUploadState(uploadStates.inprogress);
		await uploadFile(formData);
		setUploadState(uploadStates.success);
		setTimeout(() => setUploadState(uploadStates.idle), 3000);
		dispatchEvent(new CustomEvent("fileUploaded"));
		setLoad(false);
	};

	const handleClose = () => setLoad(false);
	//#endregion

	return createPortal(
		<div className='file-load-dialog-wrapper' color={theme.color}>
			<div className='file-load-dialog'>
				<div className='dialog-row'>
					<input type='file' name='file' onChange={handleChange} multiple />
				</div>
				<div className='dialog-row'>
					<div className='load-file-dialog-hint'>
						(Размер загружаемого файла не более 20 Мб)
					</div>
				</div>

				{state.selectedFile ? (
					<>
						<div className='dialog-row'>
							<label htmlFor='file-name'>Имя файла</label>
							<input
								type='text'
								value={state.fileName}
								name='file-name'
								onChange={handleChange}
							/>
						</div>
						<div className='dialog-row'>
							<label htmlFor='file-date'>Дата</label>
							<input
								type='date'
								value={state.fileDate}
								name='file-date'
								onChange={handleChange}
							/>
						</div>
					</>
				) : null}

				<div className='load-file-dialog-actions'>
					<button
						className='load-button'
						onClick={onFileUpload}
						disabled={!state.selectedFile}
					>
						Загрузить на сервер
					</button>
					<button className='close-button' onClick={handleClose}>
						Закрыть
					</button>
					{/* <svg
						style={{
							display: uploadState === uploadStates.success ? "block" : "none",
						}}
						className='checkmark'
						xmlns='http://www.w3.org/2000/svg'
						viewBox='0 0 52 52'
					>
						<circle
							className='checkmark__circle'
							cx='26'
							cy='26'
							r='25'
							fill='transparent'
						/>
						<path
							className='checkmark__check'
							fill='none'
							d='M14.1 27.2l7.1 7.2 16.7-16.8'
						/>
					</svg> */}
				</div>
				<div
					className='progress-bar'
					style={{
						display: uploadState === uploadStates.inprogress ? "block" : "none",
					}}
				>
					<div className='progress-bar-value'></div>
				</div>
			</div>
		</div>,
		document.body
	);
}
